"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlantingAndClearingSchema = void 0;
exports.PlantingAndClearingSchema = {
    geometry: 'Polygon',
    properties: {
        SID: 'int:10',
        GLOBAL_ID: 'str:38',
        OPERATION_TYPE_ID: 'int:10',
        ESTABLISHMENT_METH_CURR_ROTN_ID: 'int:10',
        FOREST_TYPE_ID: 'int:10',
        PREDOMINANT_SPECIES_ID: 'int:10',
        OTHER_PREDOMINANT_SPECIES: 'str:100',
        OTHER_TREE_SPECIES_NAME: 'str:100',
        TREE_SPECIES_NAME_ID: 'int:10',
        STEM_COUNT: 'int:10',
        COMPARTMENT_NUM: 'str:50',
        FOREST_NUMBER: 'str:50',
        CLEARANCE_TYPE_ID: 'int:10',
        START_DATE: 'date',
        END_DATE: 'date',
        HARVEST_AGE: 'float:19.11',
    },
};
